import { FC } from 'react';
import { StudentReport } from './helper/chartHelper';
import { getStudentName } from '../../CloserLook/closerLookHelper';
import { MaskedStudentData } from '../../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../../analytics/dataMasking';

interface Props {
  student: StudentReport;
  activeIndex: number;
}

const StudentRow: FC<Props> = ({ student, activeIndex }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-solid tw-border-t-0 tw-border-x-0 tw-border-neutral-200">
      <MaskedStudentData
        student={student.student}
        type={PiiTypes.FullName}
        className="tw-text-base tw-font-atkinson tw-text-neutral-950"
      >
        {getStudentName(student.student)}
      </MaskedStudentData>
      {activeIndex === 1 && (
        <span className="tw-text-base tw-font-atkinson tw-text-neutral-950">
          <span className="tw-font-bold">{student.questionsAnswered ?? 0}</span>
        </span>
      )}
    </div>
  );
};

export default StudentRow;
